"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTypesFromLambdas = exports.functionReviver = exports.functionReplacer = void 0;
var FunctionReviver = /** @class */ (function () {
    function FunctionReviver(functionName, dependencyArguments, debuggable) {
        var _this = this;
        this.reviver = function (_key, value) {
            if (typeof value === 'string') {
                // match[0] would be the whole function
                // match[1] would have all the parameters list
                // match[2] would have the function body as it is
                var rfunc = /function[^\(]*\(([^\)]*)\)\s*{([\w\W]*?)}$/;
                var rArrowFunc = /\(([^\)]*)\)\s*=>\s*{([\w\W]*?)}$/;
                var match = value.match(rfunc) || value.match(rArrowFunc);
                if (match) {
                    var args = match[1].split(',')
                        .map(function (arg) { return arg.replace(/\s+/, ''); });
                    var body = _this.functionName ? match[2].concat("//# sourceURL=" + _this.functionName + ".js") : match[2];
                    if (_this.debuggable) {
                        body = 'debugger;'.concat(body);
                    }
                    if (_this.dependencyArguments) {
                        args = args.concat(Array.from(_this.dependencyArguments));
                    }
                    return Function.apply(void 0, __spreadArrays(args, [body])); // eslint-disable-line no-new-func
                }
            }
            return value;
        };
        this.functionName = functionName;
        this.debuggable = debuggable;
        this.dependencyArguments = dependencyArguments;
    }
    return FunctionReviver;
}());
var functionReplacer = function (_key, value) {
    if (typeof value === 'function') {
        return value.toString();
    }
    return value;
};
exports.functionReplacer = functionReplacer;
var functionReviver = function (functionName, dependencyArguments, debuggable) {
    if (dependencyArguments === void 0) { dependencyArguments = null; }
    if (debuggable === void 0) { debuggable = false; }
    var funcReviver = new FunctionReviver(functionName, dependencyArguments, debuggable);
    return funcReviver.reviver;
};
exports.functionReviver = functionReviver;
var getTypesFromLambdas = function (lambdas) {
    var types = [];
    for (var _i = 0, lambdas_1 = lambdas; _i < lambdas_1.length; _i++) {
        var lambda = lambdas_1[_i];
        if (lambda.inputSchema) {
            types.push(lambda.inputSchema);
        }
        if (lambda.outputSchema) {
            types.push(lambda.outputSchema);
        }
        if (lambda.configSchema) {
            types.push(lambda.configSchema);
        }
    }
    return types;
};
exports.getTypesFromLambdas = getTypesFromLambdas;
//# sourceMappingURL=ilambda.js.map